import { Link } from "react-router-dom";
import { useState } from "react";
import "./LoginV2.css";

/**
 * Magic-link-style login mockup. v1 wires no real auth yet — that comes
 * with the Stripe Subscriptions pass. The visual exists so we can route
 * "Claim your wall" CTAs somewhere coherent.
 */
export default function LoginV2(): JSX.Element {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  return (
    <div className="at-page lvg">
      <Link to="/" className="lvg-brand">
        <span className="lvg-brand-mark" aria-hidden="true">◆</span> SubsWall
      </Link>

      <div className="lvg-card-wrap">
        <div className="lvg-card">
          {!sent ? (
            <>
              <div className="at-eyebrow">Claim your wall</div>
              <h1 className="at-display lvg-h1">Welcome back.</h1>
              <p className="at-lead lvg-lead">
                We'll send you a one-time sign-in link. No passwords.
              </p>

              <form onSubmit={(e) => { e.preventDefault(); if (email) setSent(true); }}>
                <label className="lvg-field">
                  <div className="at-eyebrow">Email</div>
                  <input
                    type="email"
                    autoFocus
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </label>
                <button type="submit" className="at-btn at-btn-primary lvg-cta">
                  Send sign-in link →
                </button>
              </form>

              <div className="lvg-divider"><span>or</span></div>

              <button type="button" className="at-btn at-btn-ghost lvg-oauth" disabled>
                <span>📺</span> Continue with YouTube
              </button>
              <button type="button" className="at-btn at-btn-ghost lvg-oauth" disabled>
                <span>🎮</span> Continue with Twitch
              </button>

              <div className="lvg-foot">
                By signing in you agree to our <Link to="/terms">Terms</Link>{" "}
                and <Link to="/privacy">Privacy Policy</Link>.
              </div>
            </>
          ) : (
            <>
              <div className="at-eyebrow">Check your inbox</div>
              <h1 className="at-display lvg-h1">Sent to {email}.</h1>
              <p className="at-lead lvg-lead">
                Click the link we just sent to finish signing in. Doesn't show up?
                Check spam, or <button type="button" onClick={() => setSent(false)} className="lvg-resend">try a different email</button>.
              </p>
            </>
          )}
        </div>

        <Link to="/" className="lvg-back">← Back to home</Link>
      </div>
    </div>
  );
}
